import jsPDF from '@doltech/jspdf';
import { PAGE_BREAK_CLASSNAME, PAGE_CLASSNAME } from './constant';
import { forEach, map } from 'lodash';

// Enable page-breaks.
type BreakPageOptions = {
  header?: {
    height: number;
  };
  footer?: {
    height: number;
  };
};

// height of children = height from page breaker to top - height from page to top
const getHeightOfPageChildren = (page: HTMLElement, pageBreaker: HTMLElement) => {
  return page.getBoundingClientRect().height - pageBreaker.getBoundingClientRect().height;
};

// Eager load all images to make sure page break height calculating works
const loadAllImages = async (source: HTMLElement) => {
  const images = source.querySelectorAll<HTMLImageElement>('img');

  const loadingImages = map(images, (image) => {
    if (!image.complete || image.naturalHeight === 0) {
      const promise = new Promise((resolve) => {
        image.onload = () => {
          resolve(true);
        };
      });

      image.loading = 'eager';
      return promise;
    }
    return Promise.resolve();
  });

  return Promise.all(loadingImages);
};
export const breakPages = async (
  doc: jsPDF,
  source: HTMLElement,
  scale: number,
  option?: BreakPageOptions
) => {
  const { getHeight } = doc.internal.pageSize;
  const pageBreaks = source.querySelectorAll<HTMLElement>(`.${PAGE_BREAK_CLASSNAME}`);
  const pages = source.querySelectorAll<HTMLElement>(`.${PAGE_CLASSNAME}`);
  if (pages.length !== pageBreaks.length) {
    throw new Error(
      `PDF Page should have page breaker with it. Please check if it contain ${PAGE_BREAK_CLASSNAME} as last element.`
    );
  }
  await loadAllImages(source);

  const pxPageHeight = (getHeight() - option.header.height - option.footer.height) / scale;

  forEach(pageBreaks, (pageBreak, index) => {
    const page = pages[index];
    pageBreak.style.display = 'block';
    const elementHeight = getHeightOfPageChildren(page, pageBreak);
    const numOfPages = Math.floor(elementHeight / pxPageHeight);
    pageBreak.style.height = `${
      pxPageHeight - (elementHeight % (pxPageHeight + numOfPages * 0.15))
    }px`;

    // Below are for debug only
    // console.log('Element height', elementHeight, numOfPages, pxPageHeight, pxPageHeight - (elementHeight % (pxPageHeight + numOfPages * 0.15)));
    // pageBreak.style.width = '1px';
    // pageBreak.style['background-color'] = 'red'
  });
};
